"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuGroup = exports.MenuItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _styles = require("../shared/styles");

var _LinkWithWrapper = require("../LinkWithWrapper");

var _excluded = ["icon", "children"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var MenuGroupLabel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e64fc6d3"
} : {
  target: "e64fc6d3",
  label: "MenuGroupLabel"
})(_styles.subheading.small, ";line-height:20px;background-color:", _styles.background.app, ";color:", _styles.color.dark, ";text-transform:uppercase;padding:10px 15px;");
var GroupContainer = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e64fc6d2"
} : {
  target: "e64fc6d2",
  label: "GroupContainer"
})();
var MenuItemLabel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e64fc6d1"
} : {
  target: "e64fc6d1",
  label: "MenuItemLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "16qjul5",
  styles: "white-space:nowrap;flex:1;text-overflow:ellipsis;overflow:hidden;min-width:0"
} : {
  name: "16qjul5",
  styles: "white-space:nowrap;flex:1;text-overflow:ellipsis;overflow:hidden;min-width:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var PureMenuItem = ( /*#__PURE__*/0, _theming.styled)(_LinkWithWrapper.LinkWithWrapper, process.env.NODE_ENV === "production" ? {
  target: "e64fc6d0"
} : {
  target: "e64fc6d0",
  label: "PureMenuItem"
})("display:flex;align-items:center;font-weight:", _styles.typography.weight.regular, ";font-size:", _styles.typography.size.s2, "px;line-height:20px;text-decoration:none;color:", _styles.color.darkest, ";transition:color 150ms ease-out;outline:0;padding:10px 15px;svg{color:", _styles.color.dark, ";}svg,img{flex:none;width:14px;height:14px;margin-right:10px;}&:hover,&:focus,&:active{background:rgba(30, 167, 253, 0.14);}");
var MenuItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var icon = _ref.icon,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(PureMenuItem, (0, _extends2["default"])({}, props, {
    ref: ref,
    role: "menuitem"
  }), icon, /*#__PURE__*/_react["default"].createElement(MenuItemLabel, null, children));
});
exports.MenuItem = MenuItem;
MenuItem.displayName = 'MenuItem';

var MenuGroup = function MenuGroup(_ref2) {
  var label = _ref2.label,
      children = _ref2.children;
  var id = (0, _reactDomInteractions.useId)();
  return /*#__PURE__*/_react["default"].createElement(GroupContainer, {
    role: "group",
    "aria-label": "Menu-group-label-".concat(id)
  }, /*#__PURE__*/_react["default"].createElement(MenuGroupLabel, {
    id: "Menu-group-label-".concat(id)
  }, label), children);
};

exports.MenuGroup = MenuGroup;